import { useState, useEffect, useCallback } from "react";
import { useLocation } from "react-router";
import BetTableTeenPatti8 from "../../casinoComponents/betTableTeenPatti8";
import CasinoHeading from "../../casinoComponents/casinoHeading";
import VideoBox from "../../casinoComponents/videoBox";
import CasinoLastResult from "../../casinoComponents/casinoLastResult";
import CasinoTableLayout from "../../casinoComponents/casinoTableLayout";
import { PokerRightSide } from "../../casinoComponents/pokerRulesCard";
import { PAIR_PLUS_RULES } from "../../casinoComponents/pokerRulesCard/pokerRules";
import PokerCardsOverlay from "../../casinoComponents/videoBox/overlays/PokerCardsOverlay";
import ResultTeen8 from "../resultui/resultTeen8/ResultTeen8";
import ViewMoreModal from "../../../components/ViewMoreModal";
import { getCasinoGameDetails, getMatchExposure, getMyBets } from "../../../apiservices/CasionApi";
import { extractCasinoGame } from "../../../utils/casinoGame";
import "../../../styles/games/poker.css";

// Reference game-header title (lastresults2 res1.cname)
const TITLE = "Teenpatti Open";

export default function TeenPatti8() {
  const [gameData, setGameData] = useState([]);
  const [exposures, setExposures] = useState({});
  const [myBets, setMyBets] = useState([]);
  const [showViewMoreModal, setShowViewMoreModal] = useState(false);

  const { pathname } = useLocation();
  const iframeSrc = `https://stream-s-43.uhdmovies.online/casino-stream?id=${extractCasinoGame(pathname)}`;
  const gameName = extractCasinoGame(pathname) || "teen8";

  useEffect(() => {
    const name = extractCasinoGame(pathname);

    const fetchGameData = async () => {
      try {
        const response = await getCasinoGameDetails(name);
        setGameData(response);
      } catch (err) {
        console.error(err.message);
      }
    };

    fetchGameData();
    const interval = setInterval(fetchGameData, 1500);

    return () => clearInterval(interval);
  }, [pathname]);

  const roundMid = gameData?.data?.data?.mid;

  const fetchExposure = useCallback(async () => {
    try {
      const user = JSON.parse(localStorage.getItem('user') || '{}');
      const userId = user?.user_id || user?.id || user?.staff_id || user?.owner_id;
      const matchId = roundMid?.toString();

      if (userId && matchId) {
        const response = await getMatchExposure(userId, matchId);
        if (response.success && response.data) {
          // Convert array to object keyed by team_name
          const exposureMap = {};
          response.data.forEach((item) => {
            exposureMap[item.team_name] = parseFloat(item.exposure_amount) || 0;
          });
          setExposures(exposureMap);
        }
      }
    } catch (error) {
      console.error('Error fetching exposure:', error);
    }
  }, [roundMid]);

  const fetchMyBetsData = useCallback(async () => {
    try {
      const user = JSON.parse(localStorage.getItem('user') || '{}');
      const userId = user?.user_id || user?.id || user?.staff_id || user?.owner_id;
      const matchId = roundMid?.toString();

      if (userId && matchId) {
        const response = await getMyBets(userId, matchId);
        if (response.success && response.bets) {
          // Map bets data to format needed for MyBet component
          const formattedBets = response.bets.map((bet) => ({
            // My Bets "Gametype" column (casino_bets.game_name, e.g. mogambo)
            description: bet.description ?? bet.game_name ?? bet.gameName,
            userName: bet.userName ?? bet.username,
            placeDate: bet.placeDate ?? bet.created_at,
            matchedBet: bet.player_name || bet.selection || "",
            odds: bet.odds || "0",
            stake: bet.stake || "0",
            type: bet.type || null // Include type field for background color
          }));
          setMyBets(formattedBets);
        }
      }
    } catch (error) {
      console.error('Error fetching my bets:', error);
    }
  }, [roundMid]);

  // Admin panel places no bets: an odds click just refreshes exposure / My Bets
  const handleBetClick = (value) => {
    if (!value) return;
    fetchExposure();
    fetchMyBetsData();
  };

  // Fetch exposure on mount and periodically
  useEffect(() => {
    const matchId = roundMid?.toString();
    if (!matchId) return;

    // Initial fetch after 2 seconds
    const timeoutId = setTimeout(() => {
      fetchExposure();
      fetchMyBetsData();
    }, 2000);

    // Periodic fetch every 2 seconds
    const intervalId = setInterval(() => {
      fetchExposure();
      fetchMyBetsData();
    }, 2000);

    return () => {
      clearTimeout(timeoutId);
      clearInterval(intervalId);
    };
  }, [fetchExposure, fetchMyBetsData, roundMid]);

  const feed = gameData?.data?.data;
  const cards = feed?.card ? String(feed.card).split(",") : [];

  return (
    <CasinoTableLayout
      tableClass="teenpattiopen"
      rightSide={<PokerRightSide bets={myBets} onViewMore={() => setShowViewMoreModal(true)} rules={PAIR_PLUS_RULES} />}
    >
      <>
        <CasinoHeading name={TITLE} roundId={feed?.mid || ""} />
        <VideoBox
          iframeSrc={iframeSrc}
          timerValue={feed?.lt}
          gameType={gameName}
          cardsOverlay={<PokerCardsOverlay card={feed?.card} variant="teen8" />}
        />
        {/* Reference renders .casino-detail once the feed has a round (casinoData.mid) */}
        {feed?.mid ? (
          <div className="casino-detail">
            <BetTableTeenPatti8 data={feed?.sub} cards={cards} onBetClick={handleBetClick} exposures={exposures} />{" "}
            <CasinoLastResult
              gameType={gameName}
              viewAllLink={`/admin/reports/casinoresult/${gameName}`}
              resultComponent={<ResultTeen8 gameType={gameName} data={gameData?.data?.lrs || []} />}
            />
          </div>
        ) : null}
      </>
      <ViewMoreModal
        show={showViewMoreModal}
        onHide={() => setShowViewMoreModal(false)}
        title="View More"
        sectionKey={gameName}
      />
    </CasinoTableLayout>
  );
}
